import React, { useEffect, useRef, useState } from "react";
import { testIdProps } from "../../../../utils/testIdProps";

const OTPInput = ({
  length = 6,
  onChange,
  idPrefix = "otp",
}: {
  length?: number;
  onChange: (otp: string) => void;
  idPrefix?: string;
}) => {
  const inputsRef = useRef<HTMLInputElement[]>([]);
  const [otpValues, setOtpValues] = useState<string[]>(Array(length).fill(""));

  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = e.target.value;

    if (!/^\d?$/.test(value)) return;

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);
    onChange(newOtpValues.join(""));

    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key === "Backspace") {
      if (otpValues[index] === "" && index > 0) {
        inputsRef.current[index - 1]?.focus();
      }

      const newOtpValues = [...otpValues];
      newOtpValues[index] = "";
      setOtpValues(newOtpValues);
      onChange(newOtpValues.join(""));
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    const paste = e.clipboardData.getData("text").trim();

    if (!/^\d+$/.test(paste) || paste.length !== length) {
      e.preventDefault();
      return;
    }

    const newOtpValues = paste.split("");
    setOtpValues(newOtpValues);
    onChange(newOtpValues.join(""));

    inputsRef.current[length - 1]?.focus();
  };

  const handleContainerClick = () => {
    const isEmpty = otpValues.every((val) => val === "");
    if (isEmpty) {
      inputsRef.current[0]?.focus();
    }
  };

  return (
    <div
      {...testIdProps(`${idPrefix}-container`)}
      className="d-flex gap-2"
      onClick={handleContainerClick}
    >
      {Array.from({ length }).map((_, i) => (
        <input
          key={i}
          id={`${idPrefix}-${i}`}
          data-testid={`${idPrefix}-${i}`}
          ref={(el) => {
            if (el) inputsRef.current[i] = el;
          }}
          className="text-center border rounded"
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={otpValues[i]}
          onPaste={i === 0 ? handlePaste : (e) => e.preventDefault()}
          // className="w-12 h-12 text-center text-lg rounded-md border focus:outline-none"
          onChange={(e) => handleChange(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          // style={{
          //   backgroundColor: "#FFFFFF",
          //   border: "1px solid #E5E7EB",
          // }}
          style={{ width: "50px", height: "50px" }}
          onFocus={(e) => {
             e.currentTarget.style.border = "1px solid #21FF91";
            e.currentTarget.style.backgroundColor = "#FAFAFA";
          }}
          onBlur={(e) => {
            e.currentTarget.style.border = "1px solid #21FF91";
            e.currentTarget.style.backgroundColor = "#FFFFFF";
          }}
        />
      ))}
    </div>
  );
};

export default OTPInput;
